<template>
  <div>
    <div class="t" v-if="type === 'NO_TICKET_COMPENSATE'">
      <div class="t-head">
        <div class="t-tr t-tr-compensate">
          <div class="t-th t-td">告知无票时间</div>
          <div class="t-th t-td">赔付比例</div>
        </div>
      </div>
      <div class="t-body">
        <div class="t-tr t-tr-compensate" :key="index" v-for="(item, index) in policyArray">
          <div class="t-td">{{ item.noTicketCompensateMatchStr }}</div>
          <div class="t-td">{{ item.noTicketCompensateModeStr }}</div>
        </div>
      </div>
    </div>

    <div class="t" v-else>
      <div class="t-head">
        <div class="t-tr t-tr-refund">
          <div class="t-th t-td">申请退票时间</div>
          <div class="t-th t-td">退票手续费</div>
        </div>
      </div>
      <div class="t-body">
        <div
          class="t-tr t-tr-refund"
          :class="{ 't-tr-active': item.active, 't-tr-expired': item.expired }"
          v-for="item in policyList"
          :key="item.id"
        >
          <div class="t-td">
            <span class="co-tag">{{ item.time }}</span
            ><span class="t-td-activetag" v-if="item.active">当前阶段</span>
          </div>
          <div class="t-td">{{ item.mode }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
const refundType = { FREE: "免费退票", FORBIDDEN: "停止退票", TICKET_AMOUNT_PERCENT: "票款金额" };

export default {
  name: "RefundPolicyTable",
  data() {
    return {
      nowTime: new Date().getTime(),
    };
  },
  props: {
    policyObj: {
      type: Object,
      default: () => {},
    },
    policyArray: {
      type: Array,
      default: () => [],
    },
    type: {
      type: String,
      required: true,
    },
    scene: {
      type: String,
    },
  },
  computed: {
    event() {
      return ((this.policyObj && this.policyObj.relations) || [])
        .map((item) => item.name)
        .join("、");
    },
    policyList() {
      this.nowTime = new Date().getTime();
      return ((this.policyObj && this.policyObj.ruleDetails) || []).map((item) => {
        const time = `${moment(item.startTime).format("MM/DD HH:mm")}至${moment(item.endTime).format("MM/DD HH:mm")}`;
        const mode =
          refundType[item.refundMode] +
          (item.refundMode === "TICKET_AMOUNT_PERCENT" ? item.refundAmount + "%" : "");
        return {
          time,
          active: item.startTime <= this.nowTime && item.endTime >= this.nowTime,
          expired: item.endTime < this.nowTime,
          mode,
          id: item.id,
        };
      });
    },
  },
};
</script>

<style lang="less" scoped>
/* 最外层容器（提供外边框和圆角） */
.t {
  margin: 8px 0;
  border-radius: 6px;
  border: 1px solid #f2f2f2;
  overflow: hidden;
  background-color: #ffffff;
}

/* 表头背景 */
.t-head {
  background-color: #f5f5f5;
}

/* Grid 行基础样式 */
.t-tr {
  display: grid;
  width: 100%;
  min-height: 37px;
  border-bottom: 1px solid #f2f2f2; /* 横向网格线 */
  font-size: 13px;

  /* 场景一：左侧 125px，右侧自适应 */
  &-compensate {
    grid-template-columns: 125px 1fr;
  }

  /* 场景二：左侧自适应，右侧 120px */
  &-refund {
    grid-template-columns: 1fr 120px;
  }

  /* 当前激活态样式 */
  &-active {
    background: linear-gradient(90deg, #ffeff4 0%, #ffffff 35%);
  }

  /* 过期状态样式 */
  &-expired {
    .t-td {
      color: #868c98;
      text-decoration: line-through;
    }
  }
}

/* 消除最后一行的底部网格线，防止与外边框叠加变粗 */
.t-body .t-tr:last-child {
  border-bottom: none;
}

/* 单元格公共样式 */
.t-td {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 11px;
  line-height: 16px;
  color: #262626;
  box-sizing: border-box;
  padding: 8px 12px;
  display: flex;
  overflow: visible !important;
  align-items: center; /* 保证文字在多行时依然垂直居中 */

  /* 纵向网格线：仅给每行的第一个单元格加右边框即可 */
  &:first-child {
    border-right: 1px solid #f2f2f2;
  }

  /* 当前阶段 Tag */
  .co-tag {
    padding: 2px 0;
  }
  &-activetag {
    border-style: solid;
    border-width: 1px;
    border-color: #ff2661;
    // border-color: blue;
    border-radius: 6px;
    margin-left: 4px;
    font-weight: 600;
    font-size: 9px;
    line-height: 1.5;
    color: #ff2661;
    padding: 2px 5px;
    white-space: nowrap;
    position: relative;
    z-index: 999;
  }
}

/* 表头字体加粗 */
.t-th {
  font-weight: 500;
  color: #20232d;
  font-size: 11px;
}
</style>



// WEBPACK FOOTER //
// RefundPolicyTable.vue?2e15e14e